module.exports = __webpack_public_path__ + "img/source.d89d5706.png";